import React from 'react';
import {
  Grid,
  CircularProgress,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Table,
  Paper,
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
  TableSortLabel,
  TableBody,
  Link,
  Button,
  TableFooter,
  TablePagination,
  Typography,
  Hidden,
} from '@material-ui/core';
import {
  AssessmentOutlined as AssessmentOutlinedIcon,
} from '@material-ui/icons';

import { Helmet } from 'react-helmet';

import Commify from 'comma-number';
import Moment from 'moment';

import APIServer from '../../config/server.conf.json';

import './Lotto.css';

export default class LottoMakeNumberResult extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: {
        roundlist: true,
        result: true,
      }
    }
  }

  loadMakeLottoRound = () => {
    return fetch(`${APIServer.baseUrl}/api/v1/lotto/make/round`);
  }

  loadMakeLottoResult = () => {
    return fetch(`${APIServer.baseUrl}/api/v1/lotto/make/result/${this.state.selected_round}`);
  }

  componentDidMount() {
    this.loadMakeLottoRound()
      .then((resp) => resp.json())
      .then((resp) => {
        if(resp.status === 200) {
          this.setState({
            ...this.state,
            isLoading: {
              ...this.state.isLoading,
              roundlist: false,
            },
            round_data: resp.data,
            selected_round: (resp.data.length ? resp.data[0]:0)
          }, () => {
            this.loadMakeLottoResult()
              .then((resp2) => resp2.json())
              .then((resp2) => {
                if(resp2.status === 200) {
                  this.setState({
                    ...this.state,
                    isLoading: {
                      ...this.state.isLoading,
                      result: false
                    },
                    data: resp2.data,
                  });
                }
              });
          })
        }
      });
  }

  handleRoundOnChange = (e) => {
    this.setState({
      ...this.state,
      selected_round: e.target.value
    });
  }

  handleLoadOnClick = (e) => {
    this.setState({
      ...this.state,
      isLoading: {
        ...this.state.isLoading,
        result: true,
      }
    }, () => {
      this.loadMakeLottoResult()
        .then((resp) => resp.json())
        .then((resp) => {
          if(resp.status === 200) {
            this.setState({
              ...this.state,
              isLoading: {
                ...this.state.isLoading,
                result: false,
              },
              data: resp.data
            });
          }
        });
    });
  }

  getBallClass = (num, match_count) => {
    let cls = '';

    if(num >= 1 && num <= 10) {
      cls = 'ball1';
    } else if(num >= 11 && num <= 20) {
      cls = 'ball2';
    } else if(num >= 21 && num <= 30) {
      cls = 'ball3';
    } else if(num >= 31 && num <= 40) {
      cls = 'ball4';
    } else if(num >= 41 && num <= 45) {
      cls = 'ball5';
    }

    if(match_count !== 6 && this.state.data.result_data.number.indexOf(num) === -1) {
      cls = 'not';
    }

    return cls;
  }

  render() {
    return (
      <Grid container style={{ padding: 10, minHeight: 450 }} spacing={3}>
        <Helmet
          title="로또 번호 생성 결과"
          meta={[
            { name: "description", content: "로또 번호 생성 결과" },
            { name: "keywords", content: "toolbox, tbx, 툴박스, lotto, lotto number, generator, 로또, 로또 번호, 로또 번호 생성 결과" },
            { property: "og:title", content: "로또 번호 생성 결과 - TBX" },
            { property: "og:description", content: "로또 번호 생성 결과 - TBX" },
            { property: "og:title", content: "로또 번호 생성 결과 - TBX" },
          ]}
        />
        {this.state.isLoading.roundlist &&
        <Grid item xs={12} style={{ textAlign: 'center' }}>
          <CircularProgress color="secondary" size={50} />
        </Grid>}
        {!this.state.isLoading.roundlist &&
        <Grid item xs={12}>
          <FormControl style={{ margin: 10, minWidth: 100 }}>
            <InputLabel shrink>
              회차
            </InputLabel>
            <Select
              value={this.state.selected_round}
              onChange={this.handleRoundOnChange}
            >
              {this.state.round_data.map((e, i) => {
                return (
                  <MenuItem key={i} value={e}>
                    {e}
                  </MenuItem>
                )
              })}
            </Select>
          </FormControl>
          <FormControl style={{ margin: 10 }}>
            <Button
              variant="contained"
              color="primary"
              disableElevation
              style={{ margin: 10 }}
              onClick={this.handleLoadOnClick}
            >
              조회
            </Button>
          </FormControl>
        </Grid>}
        {this.state.isLoading.result &&
        <Grid item xs={12} style={{ textAlign: 'center' }}>
          <CircularProgress color="secondary" size={50} />
        </Grid>}
        {!this.state.isLoading.result &&
        <Grid item xs={12}>
          <Paper variant="outlined" style={{ marginBottom: 10 }}>
            <TableContainer>
              <Table stickyHeader>
                <TableHead>
                  <TableRow>
                    <TableCell key="head-round">
                        #
                    </TableCell>
                    <TableCell key="head-date">
                      추첨일
                    </TableCell>
                    <TableCell key="head-number">
                      당첨번호
                    </TableCell>
                    <Hidden smDown>
                      <TableCell key="head-1st">
                        1등 (6개 일치)<br/>
                        (1게임당 당첨금액)
                      </TableCell>
                    </Hidden>
                    <Hidden smDown>
                      <TableCell key="head-2nd">
                        2등 (5개 + 보너스 숫자 일치)<br/>
                        (1게임당 당첨금액)
                      </TableCell>
                    </Hidden>
                    <Hidden smDown>
                      <TableCell key="head-3rd">
                        3등 (5개 일치)<br/>
                        (1게임당 당첨금액)
                      </TableCell>
                    </Hidden>
                    <Hidden smDown>
                      <TableCell key="head-4th">
                        4등 (4개 일치)<br/>
                        (1게임당 당첨금액)
                      </TableCell>
                    </Hidden>
                    <Hidden smDown>
                      <TableCell key="head-5th">
                        5등 (3개 일치)<br/>
                        (1게임당 당첨금액)
                      </TableCell>
                    </Hidden>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {Object.keys(this.state.data.result_data).length === 0 &&
                    <TableRow>
                      <TableCell
                        colSpan={8}
                        align="center"
                      >
                        No Data.
                      </TableCell>
                    </TableRow>
                  }
                  {this.state.data.result_data &&
                    <TableRow
                      hover
                    >
                      <TableCell>
                        <Link href={`https://www.dhlottery.co.kr/gameResult.do?method=byWin&drwNo=${this.state.data.result_data.round}`} target="new">
                          {this.state.data.result_data.round}
                        </Link>
                      </TableCell>
                      <TableCell>
                        {this.state.data.result_data.date}
                      </TableCell>
                      <TableCell>
                        {this.state.data.result_data.number.map((ee, ii) => {
                          return (<span className={`ball_645 sml ${this.getBallClass(ee)}`} key={ii}>{ee}</span>)
                        })} + {
                          <span className={`ball_645 sml ${this.getBallClass(this.state.data.result_data.bonus_number, 6)}`}>{this.state.data.result_data.bonus_number}</span>
                        }
                      </TableCell>
                      <Hidden smDown>
                        <TableCell>
                          {Commify(this.state.data.result_data.count[0])}명<br/>
                          ({Commify(this.state.data.result_data.prize_money[0])}원)
                        </TableCell>
                      </Hidden>
                      <Hidden smDown>
                        <TableCell>
                          {Commify(this.state.data.result_data.count[1])}명<br/>
                          ({Commify(this.state.data.result_data.prize_money[1])}원)
                        </TableCell>
                      </Hidden>
                      <Hidden smDown>
                        <TableCell>
                          {Commify(this.state.data.result_data.count[2])}명<br/>
                          ({Commify(this.state.data.result_data.prize_money[2])}원)
                        </TableCell>
                      </Hidden>
                      <Hidden smDown>
                        <TableCell>
                          {Commify(this.state.data.result_data.count[3])}명<br/>
                          ({Commify(this.state.data.result_data.prize_money[3])}원)
                        </TableCell>
                      </Hidden>
                      <Hidden smDown>
                        <TableCell>
                          {Commify(this.state.data.result_data.count[4])}명<br/>
                          ({Commify(this.state.data.result_data.prize_money[4])}원)
                        </TableCell>
                      </Hidden>
                    </TableRow>
                  }
                </TableBody>
              </Table>
            </TableContainer>
          </Paper>
          <Paper variant="outlined">
            <TableContainer>
              <Table stickyHeader>
                <TableHead>
                  <TableRow>
                    <TableCell key="head-numbers">
                      번호
                    </TableCell>
                    <TableCell key="head-real">
                      진짜???
                    </TableCell>
                    <Hidden smDown>
                      <TableCell key="head-count">
                        번호 갯수
                      </TableCell>
                    </Hidden>
                    <TableCell key="head-rank">
                      당첨 등수
                    </TableCell>
                    <TableCell key="head-prize-money">
                      당첨 금액
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {this.state.data.length === 0 &&
                    <TableRow>
                      <TableCell
                        colSpan={5}
                        align="center"
                      >
                        No Data.
                      </TableCell>
                    </TableRow>
                  }
                  {this.state.data.number_data.map((e, i) => {
                    return (
                      <TableRow
                        key={i}
                        hover
                        style={{
                          backgroundColor: e.result_rank === 0 ? '':'rgb(214, 255, 198)'
                        }}
                      >
                        <TableCell>
                          <Hidden smDown>
                            {e.number.map((ee, ii) => {
                              return (<span className={`ball_645 lrg ${this.getBallClass(ee, e.match_count)}`} key={ii}>{ee}</span>)
                            })}
                          </Hidden>
                          <Hidden mdUp>
                            {e.number.map((ee, ii) => {
                              return (<span className={`ball_645 sml ${this.getBallClass(ee, e.match_count)}`} key={ii}>{ee}</span>)
                            })}
                          </Hidden>
                        </TableCell>
                        <TableCell>
                          <Link href={`https://m.dhlottery.co.kr/qr.do?method=winQr&v=${this.state.data.result_data.round.toString().padStart(4, "0")}q${e.number.map((ee) => ee.toString().padStart(2, "0")).join('')}`} target="new">
                            확인하기
                          </Link>
                        </TableCell>
                        <Hidden smDown>
                          <TableCell>
                            {e.match_count}개
                          </TableCell>
                        </Hidden>
                        <TableCell>
                          {e.result_rank === 0 ? '-':`${e.result_rank}등`}
                        </TableCell>
                        <TableCell>
                          {e.prize_money === 0 ? '-':`${Commify(e.prize_money)}원`}
                        </TableCell>
                      </TableRow>
                    )
                  })}
                </TableBody>
              </Table>
            </TableContainer>
          </Paper>
        </Grid>}
      </Grid>
    );
  }
}